import React from 'react'
import { NavItem, UncontrolledTooltip } from 'reactstrap'

export const Whatsapp = ({ whatsapp }) => {
  return whatsapp ? (
    <React.Fragment>
      <NavItem className="d-sm-down-none conwayred" style={{ paddingLeft: '10px' }}>
        <a
          className="conwayred"
          id="contactwhatsapp"
          href={'tel:' + whatsapp}
          style={{ marginBottom: '0' }}
        >
          <i className="fa-brands fa-whatsapp font-weight-bold" /> {whatsapp}
        </a>
        <UncontrolledTooltip placement="left" target="contactwhatsapp">
          Whatsapp de contacto
        </UncontrolledTooltip>
      </NavItem>
      <NavItem
        className="d-down-none"
        style={{ marginLeft: '10px', borderRight: '1px solid grey', borderLeft: '1px solid grey' }}
      >
        <a href={`https://wa.me/${whatsapp}`} target="_blank">
          <img src="/whatsapp.svg" alt="Whatsapp" style={{ width: 25 }} />
        </a>
      </NavItem>
    </React.Fragment>
  ) : null
}
